<template>
  <div id="hero" class="hero-wrap style8">
    <div class="container-fluid">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6 col-md-10">
          <div class="hero-content" data-speed="0.10" data-revert="true">
            <span>Welcome To Our Orthopedics</span>
            <h1>World Best Orthopedics Specialized Treatment</h1>
            <p>
              Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus
              hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet
              vel dapibus id dolor sit amet standard dummy text ever since the
              when an unknown.
            </p>
            <div class="hero-btn">
              <a href="#appointment" class="btn style2">Book An Appointment</a>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="hero-img-one hero-bg-12 bg-f"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>